<!DOCTYPE html>
<div class="inbox-title-nudge" aria-hidden="true" [class.hidden]="phase === 'hidden'">
  <span class="nudge-text" [style.color]="textColor" [class.show]="phase === 'text'">{{ text }}</span>
  <ng-lottie [hidden]="phase !== 'arrow'" [options]="arrowOptions" class="nudge-arrow" [class.show]="phase === 'arrow'"></ng-lottie>
</div>


